import reducer from './reducers';

import searchWatcher, * as searchOperations from './operations';
import * as searchSelectors from './selectors';
import * as searchTypes from './types';

export { searchOperations, searchSelectors, searchTypes, searchWatcher };

export default reducer;
